import { jsx as _jsx } from "react/jsx-runtime";
export const StackedList = ({ id, testId, contents }) => {
    return (_jsx("div", { id: id, "data-test-id": testId, "data-eco-component": "stacked-list", className: "overflow-hidden bg-transparent", children: _jsx("ul", { className: "divide-y divide-gray-200 dark:divide-slate-800", children: contents.map((content, index) => {
                return (_jsx("li", { "data-eco-component": "stacked-list-item", children: content }, index));
            }) }) }));
};
